export type TagCategory = "love" | "career" | "health"
export type QuestionLabel = "ladies" | "trending" | "popular"

export const tapToAskCopy = {
  title: "Tap to Ask",
  love: "Love & Relationship",
  career: "Career & Finances",
  health: "Health & Well-Being",
}

export const tapToAskLabels: Record<QuestionLabel, string> = {
  trending: "TRENDING NOW",
  popular: "MOST POPULAR",
  ladies: "LADIES PICK",
}

export const tapToAskQuestions: Record<TagCategory, string[]> = {
  love: [
    "Is my husband cheating on me?",
    "Can I trust my boyfriend?",
    "Is my boyfriend loyal to me?",
    "Will we get married?",
    "When will I get married?",
    "Is my boyfriend the one I’m meant to marry?",
    "Will this marriage last?",
    "Are we truly compatible as a couple?",
    "Will we have children together?",
    "Will my ex come back?",
  ],
  career: [
    "Why am I still not successful?",
    "Am I in the wrong job?",
    "Why do I keep failing, no matter how hard I try?",
    "Should I quit my job?",
    "Is this career going anywhere?",
    "Why is money always such a struggle for me?",
    "Why do I feel so lost when it comes to work?",
    "Does my boss hate me?",
    "When will my finances improve?",
    "When will things finally start working out for me?",
  ],
  health: [
    "Why do I always feel so tired?",
    "Is there something wrong with me I’m not seeing?",
    "Why am I always anxious or overwhelmed?",
    "Is my stress affecting my health?",
    "Why do I keep getting sick or feeling low?",
    "What’s draining my energy lately?",
    "Why can’t I sleep properly anymore?",
    "Is this health issue physical—or something deeper?",
    "Why do I feel so out of balance?",
    "Is my body trying to tell me something?",
  ],
}

/** Maps a question index (per category) to a promo label. */
export const tapToAskLabelMapping: Record<TagCategory, Record<number, QuestionLabel>> = {
  love: { 0: "ladies", 2: "trending", 4: "popular" },
  career: { 1: "popular", 4: "ladies", 7: "trending" },
  health: { 0: "ladies", 3: "popular", 8: "trending" },
}
